/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

import Types from '../../../modules/types';

const {
  CONTENT_BUILDER_EFFECT: { TYPE_MAP: CBEF_MAP },
} = Types;

const isNotMask = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'MASK',
]);

const isNotMaskTypeGradient = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'GRADIENT',
]);

const isNotMaskTypeImage = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'IMAGE',
]);

const isNotMaskTypeImageSizeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'image_size',
  '!==',
  'CUSTOM',
]);

const isNotMaskTypeGradientTypeSimple = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'gradient_type',
  '!==',
  'SIMPLE',
]);

const isNotMaskTypeGradientTypeCustom = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'gradient_type',
  '!==',
  'CUSTOM',
]);

const ITEM_FIELDS = Admin.compileFromLibrary([
  ['FieldHidden', {
    name: 'type',
  }],
  // ALL
  //
  // IMAGE
  ['FieldUploadRefsHorizontal', {
    name: 'image_image',
    label: null,
    accept: 'image/jpg,image/jpeg,image/png,image/svg+xml,image/webp',
    transformations: [
      ['GM', { command: 'compress', maxWidth: 2000 }],
      ['GM', { command: 'webp' }],
    ],
    listType: 'picture',
    uploadLabel: 'Upload Image',
    maxCount: 1,
    preSkip: [isNotMaskTypeImage],
  }],
  ['FieldRadio', {
    name: 'image_repeat',
    label: null,
    initialValue: false,
    choices: [{
      label: 'Repeat',
      value: true,
    }, {
      label: 'No Repeat',
      value: false,
    }],
    block: true,
    preSkip: [isNotMaskTypeImage],
  }],
  getFilterWithCol(['FieldText', {
    name: 'image_position.x',
    label: null,
    prefix: 'Position X:',
    preSkip: [isNotMaskTypeImage],
  }], 12),
  getFilterWithCol(['FieldText', {
    name: 'image_position.y',
    label: null,
    prefix: 'Position Y:',
    preSkip: [isNotMaskTypeImage],
  }], 12),
  ['FieldRadio', {
    name: 'image_size',
    label: null,
    initialValue: 'COVER',
    choices: ['Cover', 'Contain', 'Custom'].map(label => ({
      label,
      value: label.toUpperCase(),
    })),
    block: true,
    preSkip: [isNotMaskTypeImage],
  }],
  ['FieldText', {
    name: 'image_sizeCustom',
    label: null,
    prefix: 'Custom Size:',
    skip: [isNotMaskTypeImageSizeCustom],
    preSkip: [isNotMaskTypeImage],
  }],
  // GRADIENT
  ['FieldRadio', {
    label: null,
    name: 'gradient_type',
    initialValue: 'SIMPLE',
    block: true,
    choices: [{
      label: 'Simple',
      value: 'SIMPLE',
    }, {
      label: 'Custom',
      value: 'CUSTOM',
    }],
    preSkip: [isNotMaskTypeGradient],
  }],
  // SIMPLE
  getFilterWithCol(['FieldColorPicker', {
    label: null,
    name: 'gradient_colorStart',
    prefix: 'Start Color:',
    useAlpha: true,
    skip: [isNotMaskTypeGradientTypeSimple],
    preSkip: [isNotMaskTypeGradient],
  }], 12),
  getFilterWithCol(['FieldColorPicker', {
    label: null,
    name: 'gradient_colorEnd',
    prefix: 'End Color:',
    useAlpha: true,
    skip: [isNotMaskTypeGradientTypeSimple],
    preSkip: [isNotMaskTypeGradient],
  }], 12),
  getFilterWithCol(['FieldText', {
    label: null,
    name: 'gradient_direction',
    prefix: 'Direction:',
    type: 'number',
    addonAfter: 'deg',
    align: 'right',
    initialValue: 0,
    skip: [isNotMaskTypeGradientTypeSimple],
    preSkip: [isNotMaskTypeGradient],
  }], 24),
  // CUSTOM
  getFilterWithCol(['FieldTextArea', {
    label: null,
    name: 'gradient_customValue',
    skip: [isNotMaskTypeGradientTypeCustom],
    preSkip: [isNotMaskTypeGradient],
    autoSize: { minRows: 3 },
  }], 24),
], true);

Admin.addToLibrary(
  'FieldContentBuilderEffects:MASK:ITEM',
  (config = {}) => Admin.compileFromLibrary(['FieldContentBuilderNodes', {
    name: 'mask_items',
    preSkip: [isNotMask],
    addButtonChoices: CBEF_MAP.MASK.children.mask_items.TYPE_ITEMS,
    addButtonLabel: 'Add Mask',
    pasteButtonLabel: 'Paste Mask',
    toolbarProps: {
      items: CBEF_MAP.MASK.children.mask_items.TYPE_ITEMS,
      // eslint-disable-next-line max-len
      itemsLabelsMap: CBEF_MAP.MASK.children.mask_items.TYPE_LABELS_MAP,
    },
    copyRealm: 'ContentBuilder:Effect:MASK:mask_items',
    pasteRealm: 'ContentBuilder:Effect:MASK:mask_items:*',
    fields: [
      ...ITEM_FIELDS,
    ],
    nodeType: CBEF_MAP.MASK.children.mask_items.node,
    targetable: false,
    ...config,
  }]),
);

export default [
  ...[

  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotMask, ...(fieldConfig.preSkip || [])],
    },
  ])),
  ['FieldContentBuilderEffects:MASK:ITEM', {
    name: 'mask_items',
  }],
];
